var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54948 3.22061C9.10148 3.22061 9.63087 3.4399 10.0212 3.83022C10.4115 4.22054 10.6308 4.74993 10.6308 5.30194C10.6308 5.85394 10.4115 6.38333 10.0212 6.77365C9.63087 7.16397 9.10148 7.38326 8.54948 7.38326C7.99748 7.38326 7.46809 7.16397 7.07776 6.77365C6.68744 6.38333 6.46816 5.85394 6.46816 5.30194C6.46816 4.74993 6.68744 4.22054 7.07776 3.83022C7.46809 3.4399 7.99748 3.22061 8.54948 3.22061ZM8.54948 0.0986328C12.0183 0.0986328 14.9808 2.25627 16.181 5.30194C14.9808 8.3476 12.0183 10.5052 8.54948 10.5052C5.08061 10.5052 2.1182 8.3476 0.917969 5.30194C2.1182 2.25627 5.08061 0.0986328 8.54948 0.0986328ZM2.4304 5.30194C2.99114 6.44687 3.86186 7.41153 4.94358 8.08623C6.02529 8.76092 7.2746 9.11861 8.54948 9.11861C9.82436 9.11861 11.0737 8.76092 12.1554 8.08623C13.2371 7.41153 14.1078 6.44687 14.6686 5.30194C14.1078 4.157 13.2371 3.19234 12.1554 2.51764C11.0737 1.84295 9.82436 1.48526 8.54948 1.48526C7.2746 1.48526 6.02529 1.84295 4.94358 2.51764C3.86186 3.19234 2.99114 4.157 2.4304 5.30194Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.07f07a2d511acbfa0b5e990dbf010f5b.svg";
export { ForwardRef as ReactComponent };